import { useState } from "react";
import { toast } from "sonner";
import { submitVolunteer } from "../lib/api";

const INITIAL_STATE = {
    nombres: "",
    apellidos: "",
    email: "",
    telefono: "",
    edad: "",
    ciudad: "",
    profesion: "",
    areas_interes: [],
    disponibilidad: "",
    experiencia: "",
    motivacion: "",
};

const REQUIRED_FIELDS = ["nombres", "apellidos", "email", "telefono", "edad", "ciudad", "disponibilidad", "motivacion"];

export const useVolunteerForm = () => {
    const [form, setForm] = useState(INITIAL_STATE);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

    const toggleArea = (a) =>
        setForm((f) => ({
            ...f,
            areas_interes: f.areas_interes.includes(a)
                ? f.areas_interes.filter((x) => x !== a)
                : [...f.areas_interes, a],
        }));

    const validate = () => {
        const missing = REQUIRED_FIELDS.find((k) => !form[k]);
        if (missing) {
            toast.error("Por favor completa los campos obligatorios.");
            return false;
        }
        if (form.areas_interes.length === 0) {
            toast.error("Selecciona al menos un área de interés.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);
        try {
            await submitVolunteer({ ...form, edad: parseInt(form.edad, 10) });
            setSubmitted(true);
            setForm(INITIAL_STATE);
            toast.success("¡Gracias! Recibimos tu inscripción. Pronto te contactaremos.");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Hubo un error. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };

    const reset = () => setSubmitted(false);

    return { form, set, toggleArea, loading, submitted, handleSubmit, reset };
};
